import React from "react";
import Stockists from "./component/Stockists";
import {createRoot} from "react-dom/client";

export default () => {
  const dom = document.querySelector('[data-stockists]');
  if (dom) {
    const root = createRoot(dom);
    root.render(<Stockists base={dom.getAttribute('data-base')}/>);
  }
}
